// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class SapSubmittalPrerequisiteRequest {
  estimateId: string;
  bsetUserId: string;
  userEmailId: string;
  segmentId: number;
  isServiceAgreement: boolean;
  subsegmentId: number;
  cultureId: number;
  isCollaborativeEstimate: boolean;
}
